<div class="row">
  <div class="col-md-6">
    <h5 md-dialog-title>Node Details</h5>
  </div>
  <div class="col-md-6" style="text-align: right">
    <button class="close-button" mat-icon-button (click)="close($event)">
      <i
        id="icon-abort-modal"
        class="Bosch-Ic Bosch-Ic-abort"
        aria-hidden="true"
      ></i>
    </button>
  </div>
</div>
<md-dialog-content>
  <div style="max-height: 650px; overflow-y: auto">
    <form
      [formGroup]="formMasterGroup"
      #formDirective="ngForm"
      (ngSubmit)="submit()"
      novalidate
    >
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            <h6>Add/Edit Node</h6>
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="row">
          <div class="col-md-10">
            <div class="col-md-4">
              <mat-label class="label-input pull-right"
                >Node Name: <span class="iep-required">*</span></mat-label
              >
            </div>
            <div class="col-md-8">
              <mat-form-field>
                <input
                  [(ngModel)]="nodeDetails.nodeName"
                  matInput
                  placeholder="Node Name"
                  formControlName="nodeNameCtr"
                  required
                />
                <mat-error *ngIf="isFieldHasError('nodeNameCtr', 'required')"
                  >This field is required.</mat-error
                >
                <mat-error
                  *ngIf="
                    isFieldHasError('nodeNameCtr', 'minlength') ||
                    isFieldHasError('nodeNameCtr', 'maxlength')
                  "
                >
                  Please legthen this text to 1 characters and less than 15
                  characters.
                </mat-error>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10">
            <div class="col-md-4">
              <mat-label class="label-input pull-right"
                >Assigned Input Sensing Points:
                <span class="iep-required">*</span></mat-label
              >
            </div>
            <div class="col-md-8">
              <mat-form-field>
                <mat-label>--Select Input Sensing Points--</mat-label>
                <mat-select
                  [(ngModel)]="nodeDetails.selectedInputSensors"
                  (selectionChange)="buildInputParams()"
                  formControlName="inputSensorCtr"
                >
                  <mat-option
                    *ngFor="let item of inputSensors"
                    [value]="item"
                    >{{ item.sensorName }}</mat-option
                  >
                </mat-select>
                <mat-error *ngIf="isFieldHasError('inputSensorCtr', 'required')"
                  >This field is required.</mat-error
                >
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10">
            <div class="col-md-4">
              <mat-label class="label-input pull-right"
                >Assigned Output Sensing Points:</mat-label
              >
            </div>
            <div class="col-md-8">
              <mat-form-field>
                <mat-label>--Select Output Sensing Points--</mat-label>
                <mat-select
                  [(ngModel)]="nodeDetails.selectedOutputSensors"
                  (selectionChange)="buildOutputParams()"
                  formControlName="outputSensorCtr"
                >
                  <mat-option
                    *ngFor="let item of outputSensors"
                    [value]="item"
                    >{{ item.sensorName }}</mat-option
                  >
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
      </mat-expansion-panel>
      <br />
      <!-- Button -->
      <div class="col-md-12" style="text-align: center">
        <button
          bciprimarybutton
          class="button-primary"
          type="submit"
          [disabled]="!formMasterGroup.valid"
        >
          <span>
            <mat-icon
              aria-hidden="false"
              aria-label="weather icon"
              class="bosch-ic-checkmark-frame"
              style="width: max-content"
            ></mat-icon>
          </span>
          Save
        </button>
        &nbsp;
        <button
          bciprimarybutton
          class="button-primary"
          (click)="delete($event)"
          [disabled]="actionMode === getActionModeEnum.Creating"
        >
          <span>
            <mat-icon
              aria-hidden="false"
              aria-label="weather icon"
              class="bosch-ic-delete"
              style="width: max-content"
            ></mat-icon>
          </span>
          Delete
        </button>
        &nbsp;
        <button bciprimarybutton class="button-primary" (click)="close($event)">
          <span>
            <mat-icon
              aria-hidden="false"
              aria-label="weather icon"
              class="bosch-ic-abort-frame"
              style="width: max-content"
            ></mat-icon>
          </span>
          Close
        </button>
      </div>
    </form>
  </div>
</md-dialog-content>
